import { tools } from './../helpers/tools';
import { settings } from './../settings';
import { price } from './../api/price';

class Pricelist {
    constructor(underscore) {
        this._ = underscore;
    }

    init(newSettings) {
        settings.init(newSettings);
        price.init();
    }

    load() {
        const self = this;

        price
            .get()
            .then(result => {
                const container = $('#hd_map_pricelist_table'),
                    template = self._.template($('#tmpl-hd-price-row').html()),
                    grouptemplate = self._.template($('#tmpl-hd-price-group').html());

                container.html('');
                result.result.forEach(group => {
                    container.append(grouptemplate(group));

                    group.items.forEach(item => {
                        container.append(template(item));
                    });
                });
            })
            .catch(response => {
                tools.handleError(self, response, $('#hd-map-pricelist-error'));
            })
            .finally(() => {
                $('#hd-map-pricelist-spinner').hide();
            });
    }
}

(function(hd, _) {
    hd.views = hd.views || {};
    hd.views.pricelist = new Pricelist(_);
    // eslint-disable-next-line no-undef
})((window.hd = window.hd || {}), _);



// WEBPACK FOOTER //
// ./scripts/booking/views/pricelist.js